// Greek (el) — EU MDR submission language.
// Covers the visitor-facing eIFU portal strings only; the admin console is not
// localized. Missing keys fall back to English (see src/i18n.js).
const el = {
  'show all manuals': 'προβολή όλων των εγχειριδίων',
  eifuPortalIntro:
    'Αναζητήστε και κατεβάστε τις ηλεκτρονικές οδηγίες χρήσης (eIFU) για το λογισμικό ιατροτεχνολογικών προϊόντων της RAY.',
  'Checking the latest documents.': 'Έλεγχος των πιο πρόσφατων εγγράφων.',
  'There are no manuals to display.': 'Δεν υπάρχουν εγχειρίδια για εμφάνιση.',
  Manuals: 'Εγχειρίδια',
  'Product Name': 'Όνομα προϊόντος',
  Language: 'Γλώσσα',
  'Document Name': 'Όνομα εγγράφου',
  Product: 'Προϊόν',
  Revision: 'Αναθεώρηση',
  Document: 'Έγγραφο',
  Published: 'Δημοσιεύτηκε',
  Country: 'Χώρα',
  'All countries': 'Όλες οι χώρες',
  Search: 'Αναζήτηση',
  'No results': 'Δεν βρέθηκαν αποτελέσματα',
  'appManuals.downloadHelpText':
    'Τα ληφθέντα αρχεία μπορούν να προβληθούν μέσω προγράμματος περιήγησης στο διαδίκτυο ή λογισμικού ανάγνωσης PDF.',
  'appManuals.systemRequirements':
    'Απαιτήσεις συστήματος: επεξεργαστής Intel® Core™ i3 ή ανώτερος, μνήμη 4 GB ή περισσότερη, ελεύθερος αποθηκευτικός χώρος 100 MB ή περισσότερος για την αποθήκευση του PDF.',
  'criticalNotice.badge': 'Σημαντική ειδοποίηση',
  'criticalNotice.close': 'Κλείσιμο',
};

export default el;
